module.exports = __webpack_public_path__ + "img/IR.58674d53.png";